import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import { AssistantSettingsActions, AssistantSettingsSelectors } from '@core/intelligence-data';
import { createActionResponseFactory } from '@core/ngrx-legacy';

@Injectable({ providedIn: 'root' })
export class HrAssistantSettingsDataService {
  private readonly store = inject(Store);
  private readonly settingsState = this.store.selectSignal(AssistantSettingsSelectors.state);
  private readonly settingsActionResponse = createActionResponseFactory(AssistantSettingsActions);

  public readonly settingsData = this.store.selectSignal(AssistantSettingsSelectors.data);
  public readonly settingsData$ = this.store.select(AssistantSettingsSelectors.data);
  public readonly settingsState$ = this.store.select(AssistantSettingsSelectors.state);

  public fetchSettings() {
    return this.settingsActionResponse(AssistantSettingsActions.fetch, undefined, {
      success: AssistantSettingsActions.fetchSuccess,
      failed: AssistantSettingsActions.fetchFailed,
    });
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.settingsState();
    if (pending || loaded) return;

    firstValueFrom(this.fetchSettings());
  }
}
